declare global {
  interface Window {
    __AUTOCLIPPER_OAUTH_CALLBACK_SEARCH__?: string;
  }
}

/**
 * Reads OAuth callback parameters captured before analytics scripts initialize,
 * then leaves only the callback pathname in browser history.
 */
export function consumeOAuthCallbackParams(
  fallbackSearch: string,
  callbackPath: string,
): URLSearchParams {
  const capturedSearch = window.__AUTOCLIPPER_OAUTH_CALLBACK_SEARCH__ ?? fallbackSearch;

  delete window.__AUTOCLIPPER_OAUTH_CALLBACK_SEARCH__;
  window.history.replaceState(window.history.state, document.title, callbackPath);

  return new URLSearchParams(capturedSearch);
}
